export interface GenericNotificationDto {
    id: string;
    type: string;
    messageKey: string;
    titleKey?: string;
    contextJson?: string;
    createdDateTime: string;
    confirmedDateTime?: string | null;
}

export type AppNotification = any;

export const isGenericNotification = (n: AppNotification): n is GenericNotificationDto => {
    return !!n?.type && !!n?.messageKey;
};

export const isWorkShiftNotification = (n: AppNotification): n is GenericNotificationDto => {
    return isGenericNotification(n) && n.type.startsWith("workShift.");
};

export interface NotificationListQueryParameters {
    type?: string;
    source?: number;
    onlyUnconfirmed?: boolean;
    ownerId?: string;
}